export default "__VITE_ASSET__49209579__"